import { cn } from '@/lib/utils';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-pulse rounded-md bg-background-tertiary',
        className
      )}
    />
  );
}

export function DocumentSkeleton() {
  return (
    <div className="flex items-center gap-4 px-5 py-4 border-b border-border-subtle last:border-b-0">
      <Skeleton className="w-11 h-11 rounded-xl" />
      <div className="flex-1 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
      </div>
      <Skeleton className="h-6 w-16 rounded-full" />
    </div>
  );
}

export function StatSkeleton() {
  return (
    <div className="bg-background-tertiary rounded-xl p-3 text-center">
      <Skeleton className="h-8 w-12 mx-auto mb-1" />
      <Skeleton className="h-3 w-10 mx-auto" />
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="flex items-center justify-between px-5 py-3 border-b border-border-subtle last:border-b-0">
      <Skeleton className="h-4 w-32" />
      <Skeleton className="h-4 w-16" />
    </div>
  );
}
